export default __webpack_public_path__ + "static/icon-city-5245c562627deb71b2b6fb69593a1396.svg";